// eslint-disable-next-line boundaries/element-types, no-restricted-imports
import { FilesUploadButton } from "../features/files-uploader";

export default FilesUploadButton;
